<template>
	<section class="content-section">
		<div class="row" :class="{ 'no-img': !sideImage.image }">
			<slot>
				<div class="columns column12 align-center">
					<h2 v-if="subtitle" class="subtitle">
						{{ subtitle }}
					</h2>
					<h1 v-if="title">{{ title }}</h1>
					<slot name="extra-heading" />
					<div v-parse-links v-html="content" />
					<slot name="extra-content" />
				</div>
				<div v-if="sideImage.image" class="side-image">
					<picture>
						<source :srcset="sideImage.imageWebp" type="image/webp" />
						<source :srcset="sideImage.image" />
						<img :src="sideImage.image" :alt="sideImage.imageAlt" />
					</picture>
				</div>
			</slot>
		</div>
	</section>
</template>

<script setup>
defineProps({
	title: { type: String, default: '' },
	subtitle: { type: String, default: '' },
	content: { type: String, default: '' },
	sideImage: {
		type: Object,
		default: () => ({
			image: '',
			imageAlt: '',
			imageWebp: '',
		}),
	},
});
</script>

<style lang="scss" scoped>
.row {
	max-width: 1180px;
	padding: 0 125px;
	flex-flow: row nowrap;
	align-items: center;

	.side-image {
		width: 38%;
		padding: 10px 0 10px 30px;
	}

	.column12 {
		width: 62%;
	}

	&.no-img {
		max-width: 760px;

		.column12 {
			width: 100%;
		}
	}
}

.index {
	.row {
		padding-left: 0;
		padding-right: 0;
		max-width: 660px;
	}
}

@media (max-width: 1080px) {
	.row {
		margin-left: auto;
		padding: 0 20px;
		flex-flow: column-reverse wrap;

		.column12 {
			width: 100%;
			margin-top: calc(35vh - 125px);
			position: relative;
			z-index: 2;

			h1 {
				color: #fff;
			}
		}

		&.no-img {
			.column12 {
				margin-top: 0;

				h1 {
					color: var(--header-color);
				}
			}
		}

		.side-image {
			width: auto;
			height: 35vh;
			position: absolute;
			inset: -50px -20px auto;
			padding: 0;
			z-index: 1;

			img {
				object-fit: cover;
				width: 100%;
				height: 100%;
			}
		}
	}

	.index {
		.row {
			padding-left: 40px;
			padding-right: 40px;
			max-width: 680px;
		}
	}
}
</style>
